// Custom hooks logic based on https://tkdodo.eu/blog/working-with-zustand

import { create } from 'zustand'
import { devtools, persist, createJSONStorage } from 'zustand/middleware'

type State = {
  coupon?: string
}

type Actions = {
  setCoupon: (coupon: string) => void
  reset: () => void
}

const initialState: State = {
  coupon: undefined,
}

// ⬇️ not exported, so that no one can subscribe to the entire store
const useGlobalStore = create<State & Actions>()(
  devtools(
    persist(
      (set) => ({
        ...initialState,
        setCoupon: (coupon) => set({ coupon }),
        reset: () => set(initialState),
      }),
      {
        name: 'default-state',
        storage: createJSONStorage(() => localStorage),
      }
    )
  )
)

// 💡 exported - consumers don't need to write selectors
export const useCoupon = () => useGlobalStore((state) => state.coupon)
export const useSetCoupon = () => useGlobalStore((state) => state.setCoupon)

// 🎉 one selector for all our actions
// export const useGlobalActions = () => useGlobalStore((state) => state.actions)
